'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

interface SearchBarProps {
  onSearch: (query: string) => void;
}

const SearchBar = ({ onSearch }: SearchBarProps) => {
  const { t } = useLanguage();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchQuery);
  };

  const handleClear = () => {
    setSearchQuery('');
    onSearch('');
  };

  return (
    <form data-component-id="src/app/product-catalog/components/SearchBar.tsx:26:4" data-component-path="src/app/product-catalog/components/SearchBar.tsx" data-component-line="26" data-component-end-line="49" data-component-file="SearchBar.tsx" data-component-name="form" data-component-content="%7B%22elementName%22%3A%22form%22%2C%22className%22%3A%22relative%20w-full%22%7D" onSubmit={handleSubmit} className="relative w-full">
      <Icon data-component-id="src/app/product-catalog/components/SearchBar.tsx:27:6" data-component-path="src/app/product-catalog/components/SearchBar.tsx" data-component-line="27" data-component-end-line="31" data-component-file="SearchBar.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22MagnifyingGlassIcon%22%2C%22className%22%3A%22absolute%20left-4%20top-1%2F2%20-translate-y-1%2F2%20text-muted-foreground%22%7D"
        name="MagnifyingGlassIcon"
        size={20}
        className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground"
      />
      <input data-component-id="src/app/product-catalog/components/SearchBar.tsx:32:6" data-component-path="src/app/product-catalog/components/SearchBar.tsx" data-component-line="32" data-component-end-line="38" data-component-file="SearchBar.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22text%22%2C%22value%22%3A%22%5Bvar%3AsearchQuery%5D%22%2C%22className%22%3A%22w-full%20border%20border-border%20bg-input%20py-3%20pl-12%20pr-12%20font-caption%20text-sm%20text-foreground%20transition-smooth%20placeholder%3Atext-muted-foreground%20focus%3Aoutline-none%20focus-ring%22%7D"
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder={t('common.searchPlaceholder')}
        className="w-full border border-border bg-input py-3 pl-12 pr-12 font-caption text-sm text-foreground transition-smooth placeholder:text-muted-foreground focus:outline-none focus-ring"
      />
      {searchQuery && (
        <button data-component-id="src/app/product-catalog/components/SearchBar.tsx:40:8" data-component-path="src/app/product-catalog/components/SearchBar.tsx" data-component-line="40" data-component-end-line="47" data-component-file="SearchBar.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%2C%22className%22%3A%22absolute%20right-4%20top-1%2F2%20-translate-y-1%2F2%20text-muted-foreground%20transition-smooth%20hover%3Atext-foreground%22%7D"
          type="button"
          onClick={handleClear}
          className="absolute right-4 top-1/2 -translate-y-1/2 text-muted-foreground transition-smooth hover:text-foreground"
          aria-label="Clear search"
        >
          <Icon data-component-id="src/app/product-catalog/components/SearchBar.tsx:46:10" data-component-path="src/app/product-catalog/components/SearchBar.tsx" data-component-line="46" data-component-end-line="46" data-component-file="SearchBar.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22XMarkIcon%22%7D" name="XMarkIcon" size={20} />
        </button>
      )}
    </form>
  );
};

export default SearchBar;